import React, {useState} from 'react';
import NavBar from '../components/NavBar';
import HomeImage from '../images/Watcher_HomeScreen.png';
import RequestsPageImage from '../images/Watcher_RequestsPage.png';
import PurchasesPageImage from '../images/Watcher_PurchasesPage.png';
import InventoryPageImage from '../images/Watcher_InventoryPage.png';
import SalesPageImage from '../images/Watcher_SalesPage.png';
import axios from 'axios';


const LandingPage = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [contactMessage, setContactMessage] = useState('');
    const [contactTitle, setContactTitle] = useState('');
    const [error, setError] = useState(null);

    const price = 39;

    const handleContactSubmit = async (e) => {
    

        try {
            // eslint-disable-next-line
            await axios.post(
                process.env.REACT_APP_SERVER_URL + '/api/user/contact-form',
                {name, email, contactTitle, contactMessage}
            )
        } catch (e) {
            setError(e.response.data.error)
        }

        setName('');
        setEmail('');
        setContactMessage('');
        setContactTitle('');
    }

    
    return (
        <div className="landing-page">
            <NavBar />

            <div id='intro'>
                <h1>Inventory management for watch dealers.</h1>
                <p>
                    Watcher was designed with watch dealers in mind. No more using generic 
                    software to manage your unique business.
                </p>
                <button className='btn btn-light'><a className="nav-link" href="/signup">Sign Up!</a></button>
            </div>

            <div id="overview-section">
                <img src={HomeImage} alt="Watcher Home Screen" />
                <div className="overview-details">
                    <h3>Track your inventory end to end</h3>
                    <p>
                        From customer requests to sale orders and everything inbetween including purchases and 
                        active inventory, track your watches through their whole lifecycle.
                    </p>
                </div>
            </div>

            <div id="pages-section">
                <div className="page-details">
                    <h3>View client requests</h3>
                    <img src={RequestsPageImage} alt="Requests Page" />
                </div>
                <div className="page-details">
                    <h3>Track your purchases</h3>
                    <img src={PurchasesPageImage} alt="Purchases Page" />
                </div>
                <div className="page-details">
                    <h3>See whats currently in your inventory</h3>
                    <img src={InventoryPageImage} alt="Inventory Page" />
                </div>
                <div className="page-details">                 
                    <h3>Understand your monthly sales</h3>
                    <img src={SalesPageImage} alt="Sales Page" />
                </div>
            </div>

            <div id="pricing-section">
                <div className="pricing-header">
                    <h1>One Plan, One Monthly Price.</h1>
                    <h1>Try Free For 7 days.</h1>
                    <h1>Cancel Anytime.</h1>
                </div>
                <div className="price-tile">
                    <h3>${price}/month</h3>
                    <ul>
                        <li>Inventory Tracking</li>
                        <li>Customer Request Management</li>
                        <li>Purchase Tracking</li>
                        <li>Sale Order Creation</li>
                        <li>Unlimited Amount of Documents</li>
                        <li>Unlimited Customer Support</li>
                    </ul>
                </div>
            </div>

            <div id="contact-section">
                <h2>Contact Us</h2>
                <form className="contact-form" onSubmit={handleContactSubmit}>
                    <div className="contact-detail">
                        <label>Name</label>
                        <input 
                            type="text"
                            required
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                        />
                    </div>
                    <div className="contact-detail">
                        <label>Email</label>
                        <input 
                            type="text"
                            required
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                        />
                    </div>
                    <div className="contact-detail">
                        <label>Title</label>
                        <input 
                            type="text"
                            required
                            onChange={(e) => setContactTitle(e.target.value)}
                            value={contactTitle}
                        />
                    </div>
                    <div className="contact-detail">
                        <label>Message</label>
                        <textarea
                            className="form-control"
                            required
                            onChange={(event) => setContactMessage(event.target.value)}
                            value={contactMessage}
                            rows={10}
                            cols={40}
                        /> 
                    </div>

                    <button type="submit" className="btn btn-light">Send Message</button>
                </form>
                {error && <div className="error">{error}</div>}
            </div>
        </div>
    )
}

export default LandingPage;